module.exports = __webpack_public_path__ + "static/img/slide_7.18cb467.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/slider/slide_7.png
// module id = oHPe
// module chunks = 0